<template>
    <div class="common-dialog" :class="dialogSize">
        <div class="title">
            <span class="title-txt">{{ title }}</span>
            <div v-show="showCloseButton" class="close-btn" @click="closeDialog"></div>
        </div>
        <slot name="msg"></slot>
        <slot name="buttons"></slot>
    </div>
</template>
<script>
export default {
    name: "CommonDialog",
    data: function () {
        return {

        }
    },
    props: {
        title: String,
        size: String,
        showCloseButton: {
            type: Boolean,
            default: true
        }

    },
    methods: {
        closeDialog() {
            this.$emit("close");
        }
    },
    computed: {
        dialogSize: function () {
            return {
                large: this.size == "large"
            }

        }
    }

}
</script>
<style scoped>
.common-dialog {
    background: white;
    border: rgb(0, 89, 173) 0.2rem solid;
    border-radius: 2rem;
    height: 50vh;
    width: 80vw;

    max-width: 505px;
    max-height: 209px;

    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.large {
    height: 30vh;
    width: 32vw;
}

.title {
    margin-top: 2rem;
}

.title-txt {
    display: inline-block;
    font-size: 1.5rem;
    font-weight: bold;
}

.close-btn {
    position: absolute;
    top: 2rem;
    right: 1rem;
}

.button-slot {
    margin-bottom: 2rem;
}
</style>